import React from "react";

export default () => (
  <div className="bg-white h-16 flex items-center fixed left-0 top-0 w-full shadow">
    <div className="container mx-auto px-2">
      <img src="/images/logo-with-name.png" alt="Q-CTRL" className="h-12" />
    </div>
  </div>
);
